import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekday);

export const LAST_TWO_IN_ARRAY = -2;
export const determineView = (data) => {
  let view = 'book';
  if (data?.isWorkOrderView && data?.isWorkOrderView === true) {
    return `order_details`
  }
  if (data?.appointmentWindowId) {
    return `manage`
  }

  return view;
}
// Keeps the confirmation number in the URL so a refresh of the work order view can log in again
export const stampWorkOrderRef = (data) => {
  if (!data?.isWorkOrderView || !data?.confirmationNumber) return;
  const url = new URL(window.location.href);
  url.searchParams.set('ref', data.confirmationNumber);
  url.searchParams.set('have_expiry', 'false');
  window.history.replaceState({}, '', url);
};
export const LOCAL_HOST = 'localhost';

export const renderFormattedAppointmentDate = (startTime, endTime, formattedTime, formattedDate) => {
  if (!startTime || !endTime) return '';

  const dateFormatString = formattedDate || 'DD/MM/YYYY';
  const timeFormatString = formattedTime || 'hh:mm a';

  const start = dayjs(startTime).tz(dayjs.tz.guess());
  const end = dayjs(endTime).tz(dayjs.tz.guess());

  const formattedStartDate = start.format(dateFormatString);
  const formattedEndDate = end.format(dateFormatString);
  const formattedStartTime = start.format(timeFormatString);
  const formattedEndTime = end.format(timeFormatString);

  return formattedStartDate === formattedEndDate
    ? `${formattedEndDate}, ${formattedStartTime} - ${formattedEndTime}`
    : `${formattedEndDate}, ${formattedStartTime} - ${formattedStartDate}, ${formattedEndTime}`;
}

export const convertToDateString = (dateObj) => {
  const month = ("0" + (dateObj.getUTCMonth() + 1)).slice(-2);
  const day = dateObj.getUTCDate();
  const year = dateObj.getUTCFullYear();
  return day + "/" + month + "/" + year;
}

export const getWeek = (startOfWeek) => {
  const months = [];
  const years = [];
  const days = []

  for (let i = 0; i < 7; i++) {
    const day = startOfWeek.add(i, 'day');
    days.push(day);
    months.push(day.format('MMM'));
    years.push(day.format('YYYY'));
  }

  return {
    days,
    months: [...new Set(months)],
    years: [...new Set(years)]
  };
}

export const getDaysInMonth = (date) => {
  const startOfMonth = dayjs(date).startOf('month');
  const daysInMonth = [];

  for (let i = 0; i < startOfMonth.daysInMonth(); i++) {
    daysInMonth.push(startOfMonth.add(i, 'day'));
  }

  return daysInMonth;
}

export const getStartOfWeek = currentWeek => dayjs().weekday(currentWeek * 7);

export const generateHtmlId = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);

export const determineOtpMethod = (currentMothod = '', times) => {
  if (times < 3) return;
  if (times > 3) return currentMothod;

  switch (currentMothod.toLowerCase()) {
    case 'sms':
      return 'email'
    case 'email':
      return 'sms'
    default:
      return;
  }
}

export const getDaysWithAvailableTimeSlots = (timeslots = []) => {
  const days = [];

  timeslots.forEach((t, i) => {
    if (t.length){days.push(new Date(t[0].startTimeInUTC).getUTCDate())};
  });

  return days;
}

export const isProdURL = () => {
  if(window.location.hostname === LOCAL_HOST) {
    return false;
  }

  if(window.location.hostname.split('.').slice(LAST_TWO_IN_ARRAY).join('.') === 'devzinier.net') {
    return false;
  };
  return true;
};

export const getFriendlyTimezoneName = timezoneId => {
  if (!timezoneId) return '';

  const now = new Date();
  const intlOptions = {
      timeZone: timezoneId,
      timeZoneName: 'longGeneric'
  };
  const formatter = new Intl.DateTimeFormat('en-US', intlOptions);
  const parts = formatter.formatToParts(now);
  
  const timeZonePart = parts.find(part => part.type === 'timeZoneName').value;
  const offset = dayjs().tz(timezoneId).format('Z');
  
  return `(GMT${offset}) ${timeZonePart}`;
}

// Task sites come as { lat, long } strings; the map expects numeric { lat, lng }
export const toLatLng = (site) => {
  const lat = Number(site?.lat);
  const lng = Number(site?.long);
  return site?.lat && site?.long && Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : undefined;
};

// Name and phone of a contact, shown as "Name | Phone"
export const formatContact = (name, phone) => [name, phone].filter(Boolean).join(' | ');

// "jane.doe@email.com" -> "j******e@email.com"
export const maskEmail = (email) => {
  const [name, domain] = (email || '').split('@');
  if (!name || !domain) return '';
  return name.length < 3 ? `${name[0]}*@${domain}` : `${name[0]}${'*'.repeat(name.length - 2)}${name.slice(-1)}@${domain}`;
};

export const STORAGE_LOCALE_KEY = 'z-cp-locale';

export const getLocale = () => {
  const saved = localStorage.getItem(STORAGE_LOCALE_KEY);
  const browserLocale = saved || (navigator.language || navigator.userLanguage || 'en').toLowerCase();
  return {
    locale: browserLocale.split('-')[0],
    region: browserLocale.split('-')[1]
  };
};
